module.exports = __webpack_public_path__ + "static/media/PC5-2.71124a1f.jpg";